import { useI18n } from "../i18n/LanguageContext";
import { LOCALE_LABELS, SUPPORTED_LOCALES } from "../i18n/translations";

/**
 * Borealis Reserve language switcher.
 * Variant "compact" → for top-right of public pages (tight tracking, mono uppercase)
 * Variant "header"  → for the authenticated portal header (matches PortalLink style)
 */
export default function LanguageSwitcher({ variant = "compact" }) {
  const { locale, setLocale } = useI18n();

  return (
    <div
      className="flex items-center gap-1"
      data-testid="language-switcher"
    >
      {SUPPORTED_LOCALES.map((loc, idx) => {
        const active = locale === loc;
        return (
          <span key={loc} className="flex items-center gap-1">
            {idx > 0 && (
              <span
                aria-hidden="true"
                className="font-mono-fin text-[0.62rem]"
                style={{ color: "var(--br-line-bright)" }}
              >
                ·
              </span>
            )}
            <button
              type="button"
              onClick={() => setLocale(loc)}
              className="font-mono-fin tracking-[0.18em] uppercase transition-colors duration-200"
              style={{
                fontSize: variant === "header" ? "0.68rem" : "0.66rem",
                color: active ? "var(--br-bronze-soft)" : "var(--br-text-dim)",
                cursor: active ? "default" : "pointer",
                padding: "4px 2px",
                background: "transparent",
                border: 0,
              }}
              aria-current={active ? "true" : undefined}
              data-testid={`lang-${loc}`}
            >
              {LOCALE_LABELS[loc]}
            </button>
          </span>
        );
      })}
    </div>
  );
}
